import { configureStore } from '@reduxjs/toolkit';
import appReducer from './features/appSlice';
import mapReducer from './pages/MapPage/mapSlice';

export const store = configureStore({
    reducer: {
        app: appReducer,
        map: mapReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Игнорируем предупреждения для определенных типов действий
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

